import { Tag } from "antd";
import styled from "styled-components";

export const StyledTag = styled(Tag)`
    margin: 0;
`;
